import { render } from "./PaginaResolucao.vue?vue&type=template&id=2caac6e7"
import script from "./PaginaResolucao.vue?vue&type=script&lang=js"
export * from "./PaginaResolucao.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__